import Timeout from '@derpierre65/vue-utils/src/mixins/Timeout'

export default {
  mixins: [Timeout],
  data () {
    return {
      progress: 0,
      currentSecond: 0,
      volume: 0.5,
      isMuted: false,
      playing: false,
      playerInitialized: false,
      currentTrack: {
        id: null,
        isSfx: false,
        name: '',
        artists: []
      }
    }
  },
  watch: {
    volume (newVolume) {
      if (!this.playerInitialized) {
        return
      }

      this.setTimeout(() => {
        this.$store
          .dispatch('jukebox/getInstance')
          .then((jukebox) => {
            jukebox.volume(newVolume)
          })
      }, 100, 'updateVolume')
    }
  },
  computed: {
    artists () {
      const mainArtists = this.currentTrack.artists
        .filter(artist => artist.role === 'MainArtist')
        .map(artist => artist.name)
      const featArtists = this.currentTrack.artists
        .filter(artist => artist.role !== 'MainArtist')
        .map(artist => artist.name)
      let artists = mainArtists.join(', ')

      if (featArtists.length) {
        artists += ' feat. ' + featArtists.join(', ')
      }

      return artists
    }
  },
  created () {
    this.$store
      .dispatch('jukebox/hasInstance')
      .then((hasInstance) => {
        if (!hasInstance) {
          return Promise.resolve(null)
        }

        this.playerInitialized = true

        return this.$store.dispatch('jukebox/getInstance')
      })
      .then((jukebox) => {
        if (!jukebox) {
          return
        }

        jukebox.on('state.updated', this.stateUpdate)
        jukebox.on('player.play', this.playerPlay)
        jukebox.on('player.pause', this.playerPause)

        this.playing = jukebox.isPlaying()
      })
  },
  destroyed () {
    if (!this.playerInitialized) {
      return
    }

    this.$store
      .dispatch('jukebox/getInstance')
      .then((jukebox) => {
        jukebox.off('state.updated', this.stateUpdate)
        jukebox.off('player.play', this.playerPlay)
        jukebox.off('player.pause', this.playerPause)
      })
  },
  methods: {
    playerPlay () {
      this.currentSecond = 0
      this.playing = true
    },
    playerPause () {
      this.playing = false
    },
    stateUpdate (state) {
      const seconds = Math.floor(state.position)

      // only update progressbar on full seconds for a better bar
      if (state.percentCompleted >= 100 || seconds === 0 || seconds !== this.currentSecond) {
        this.progress = state.percentCompleted
        this.currentSecond = seconds

        this.currentTrack.id = state.track.id
        this.currentTrack.name = state.track.name
        this.currentTrack.artists = state.track.artists
        this.currentTrack.isSfx = typeof state.track.free !== 'undefined'
      }

      if (state.percentCompleted >= 100) {
        this.playing = false
      }
    },
    forward () {
      if (!this.playerInitialized) {
        return
      }

      this.$store
        .dispatch('jukebox/getInstance')
        .then((jukebox) => {
          jukebox.next()
        })
    },
    previous () {
      if (!this.playerInitialized) {
        return
      }

      this.$store
        .dispatch('jukebox/getInstance')
        .then((jukebox) => {
          jukebox.previous()
        })
    },
    setProgress (percentage) {
      if (!this.playerInitialized) {
        return
      }

      this.$store
        .dispatch('jukebox/getInstance')
        .then((jukebox) => {
          jukebox.seekTo(percentage)
        })
    },
    togglePlay () {
      if (!this.playerInitialized) {
        this.$router.push({ name: 'dashboard-jukebox-genres' })

        return
      }

      this.$store
        .dispatch('jukebox/getInstance')
        .then((jukebox) => {
          if (jukebox.isPlaying()) {
            jukebox.pause()
          } else {
            jukebox.continue()
          }
        })
    },
    toggleMute () {
      if (this.isMuted) {
        this.volume = this.oldVolume
      } else {
        this.oldVolume = this.volume
        this.volume = 0
      }

      this.isMuted = !this.isMuted
    }
  }
}
